module.exports = __webpack_public_path__ + "img/shape-8.882f07c0.svg";